import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import SavannahHeroSection from "./components/HeroSection";
import SavannahStickyNav from "./components/StickyNav";
import SavannahProcessingTimeSection from "./components/ProcessingTimeSection";
import SavannahServicesSection from "./components/ServicesSection";
import SavannahLocalAreaSection from "./components/LocalAreaSection";
import SavannahTestimonialsSection from "./components/TestimonialsSection";
import SavannahAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SavannahComparisonSection from "./components/ComparisonSection";
import SavannahMistakesSection from "./components/MistakesSection";
import SavannahHowItWorksSection from "./components/HowItWorksSection";
import SavannahFAQSection, { faqs } from "./components/FAQSection";
import SavannahHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SavannahFinalCTA from "./components/FinalCTA";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function SavannahPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Savannah"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/savannah"
        title="Emergency Passport Savannah, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Savannah, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Savannah and coastal Georgia travelers. Get your emergency passport fast!"
        keywords="expedited passport, emergency passport, Savannah passport, same day passport Savannah, fast passport Georgia"
        geoPlacename="Savannah, Georgia"
        geoPosition="32.0835;-81.0998"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
      />
      <SavannahHeroSection />
      <SavannahStickyNav />
      <SavannahProcessingTimeSection />
      <SavannahServicesSection />
      <SavannahLocalAreaSection />
      <SavannahTestimonialsSection />
      <SavannahAcceptanceFacilitiesSection />
      <SavannahComparisonSection />
      <SavannahMistakesSection />
      <SavannahHowItWorksSection />
      <SavannahFAQSection />
      <SavannahHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/savannah" state="GA" />
      <SavannahFinalCTA />
    </div>
  );
}